import { SVGFC } from '@repo/toolkit/types'

const TelephoneIcon: SVGFC = ({ color = 'white', filled: _filled, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.8 13.9617C12.9372 15.9218 8.18573 11.213 10.0555 9.24524C11.1973 8.04356 9.90774 6.67077 9.19374 5.66043C7.85361 3.76652 4.91281 6.38144 5.00147 8.04512C5.28381 13.2921 10.9593 19.5097 16.4551 18.9668C18.174 18.7972 20.1496 15.6923 18.1772 14.5575C17.1917 13.9897 15.8376 12.8697 14.8 13.961"
        stroke={color}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default TelephoneIcon
